export default {
    namespaced: true,

    state: {
        sessionId: '',   // 当前会话ID
        spCaseId: ''     // 当前选中的虚拟病人病历ID
    },

    mutations: {
        SET_SESSION_ID(state, id) {
            state.sessionId = id
        },
        SET_SP_CASE_ID(state, id) {
            state.spCaseId = id
        }
    },

    actions: {},
    getters: {}
}